var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"id":"footer","app":"","inset":""}},[_c('p',{staticClass:"footer__paragraph caption mb-0"},[_vm._v(" Административная панель BMS Group, "+_vm._s(new Date().getFullYear())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }